import { Flex } from '@chakra-ui/react'
import React from 'react'
import Countdown, { CountdownRendererFn, zeroPad } from 'react-countdown'

type ReactCountdownProps = {
  date: string | number | Date | undefined
}

const renderer: CountdownRendererFn = (props) => {
  const { hours, minutes, seconds, completed, days } = props
  if (completed) {
    return null
  } else {
    return (
      <Flex alignItems="center" justifyContent="center">
        offer expires in {days ? `${days} Day${days > 1 ? 's' : ''}` : ''}{' '}
        {zeroPad(hours)} Hr {zeroPad(minutes)} Min {zeroPad(seconds)} Sec
      </Flex>
      // <span className="flex items-center text-skin-inverted font-semibold ms-2 pe-6">
      //   <span className="flex items-center justify-center min-w-[30px] md:min-w-[37px] min-h-[30px] bg-skin-fill text-skin-base rounded p-1 mx-1 md:mx-1.5">
      //     {zeroPad(hours)} Hr
      //   </span>
      //   :
      //   <span className="flex items-center justify-center min-w-[30px] md:min-w-[37px] min-h-[30px] bg-skin-fill text-skin-base rounded p-1 mx-1 md:mx-1.5">
      //     {zeroPad(minutes)} Min
      //   </span>
      //   :
      //   <span className="flex items-center justify-center min-w-[30px] md:min-w-[37px] min-h-[30px] bg-skin-fill text-skin-base rounded p-1 mx-1 md:mx-1.5">
      //     {zeroPad(seconds)} Sec
      //   </span>
      // </span>
    )
  }
}

const ReactCountdown: React.FC<ReactCountdownProps> = ({ date }) => {
  return <Countdown date={date} renderer={renderer} />
}

export default ReactCountdown
